export default {
  'menu.welcome': 'Welcome',
  'menu.more-blocks': 'More Blocks',
  'menu.home': 'Home',
  'menu.admin': 'Admin',
  'menu.login': 'Login',
  'menu.pam': 'PAM',
  'menu.rgs': 'RGS',
  'menu.rgs.tickets': 'Tickets',
  'menu.rgs.wagers': 'Buyins',
  'menu.f3': 'F3',
  'menu.f3.hosts': 'Hosts',
  'menu.f3.rooms': 'Rooms',
  'menu.f3.games': 'Games',
  'menu.rummy': 'Rummy',
  'menu.rummy.rummy-tables': 'Tables',
  'menu.rummy.rummy-games': 'Games',
  'menu.callbreak': 'Callbreak',
  'menu.snl': 'Snakes And Ladders',
  'menu.snl.create-table': 'Create Table',
  'menu.callbreak.callbreak-tables': 'Tables',
  'menu.callbreak.callbreak-games': 'Games',
  'menu.pam.players': 'Players',
  'menu.pam.transactions': 'Transactions',
  'menu.pam.kycs': 'KYCs',
  'menu.pam.withdrawals': 'Withdrawals',
  'menu.pam.payments': 'Withdrawal Accounts',
  'menu.admin.sample': 'Sample',
  'menu.register': 'Register',
  'menu.register.result': 'Register Result',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': 'Analysis',
  'menu.dashboard.monitor': 'Monitor',
  'menu.dashboard.workplace': 'Workplace',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Form',
  'menu.form.basic-form': 'Basic Form',
  'menu.form.step-form': 'Step Form',
  'menu.form.step-form.info': 'Step Form(write transfer information)',
  'menu.form.step-form.confirm': 'Step Form(confirm transfer information)',
  'menu.form.step-form.result': 'Step Form(finished)',
  'menu.form.advanced-form': 'Advanced Form',
  'menu.list': 'List',
  'menu.list.table-list': 'Search Table',
  'menu.list.basic-list': 'Basic List',
  'menu.list.card-list': 'Card List',
  'menu.list.search-list': 'Search List',
  'menu.list.search-list.articles': 'Search List(articles)',
  'menu.list.search-list.projects': 'Search List(projects)',
  'menu.list.search-list.applications': 'Search List(applications)',
  'menu.profile': 'Profile',
  'menu.profile.basic': 'Basic Profile',
  'menu.profile.advanced': 'Advanced Profile',
  'menu.result': 'Result',
  'menu.result.success': 'Success',
  'menu.result.fail': 'Fail',
  'menu.exception': 'Exception',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Trigger',
  'menu.account': 'Account',
  'menu.account.center': 'Account Center',
  'menu.account.settings': 'Account Settings',
  'menu.account.trigger': 'Trigger Error',
  'menu.account.logout': 'Logout',
  'menu.editor': 'Graphic Editor',
  'menu.editor.flow': 'Flow Editor',
  'menu.editor.mind': 'Mind Editor',
  'menu.editor.koni': 'Koni Editor',
  'menu.promotions': 'Promotions',
  'menu.promotions.banners': 'Banners',
  'menu.promotions.coupons': 'Coupons',
  'menu.promotions.user-segment': 'User Segment',
  'menu.promotions.create-segment': 'Create Segment',
  'menu.promotions.create-redeem-code': 'Create Redeem Code',
  'menu.promotions.redeem-code': 'Redeem Code',
  'menu.promotions.create-scratch-card': 'Create Scratch Card',
  'menu.promotions.scratch-card': 'Scratch Card',
  'menu.promotions.freebets': 'FreeBets',
  'menu.promotions.freebets.freebets': 'FreeBets',
  'menu.promotions.freebets."Freebet-instances': 'FreeBet Instance',
  'menu.promotions.Freebet-instances': 'FreeBet-Instances',
  'menu.promotions.comboboost': 'ComboBoosts',
  'menu.promotions.comboboost-instance': 'ComboBoost Instances',
  'menu.promotions.comboboostInstance': 'ComboBoost Instances',
  'menu.bingo': 'Bingo',
  'menu.bingo.bingo-tables': 'Tables',
  'menu.bingo.bingo-games': 'Games',
  'menu.ludo': 'Ludo',
  'menu.ludo.ludo-tables': 'Tables',
  'menu.ludo.ludo-games': 'Games',
  'menu.lingo.tables': 'Tables',
  'menu.fantasy': 'Fantasy',
  'menu.fantasy.contest-templates': 'Contest Templates',
  'menu.fantasy.matches': 'Matches',
  'menu.fantasy.contests': 'Contests',
  'menu.setup': 'Setup',
  'menu.setup.roles': 'Roles',
  'menu.setup.users': 'Users',
  'menu.setup.create-users': 'Create User',
  'menu.bots': 'Bots',
  'menu.bots.bots-list': 'Players',
  'menu.games': 'Games',
  'menu.games.tables': 'Tables',
  'menu.games.create game': 'Create Game',
  'menu.gamezop': 'Gamezop',
  'menu.gamezop.gamezop-tables': 'Tables',
  'menu.gamezop.create-tables': 'Create Tables',
  'menu.cms': 'CMS',
  'menu.cms.cms-lobbies': 'Lobbies',
  'menu.cms.cms-games': 'Games',
  'menu.cms.skins': 'Skins',
  'menu.cms.event-ticker': 'Event Ticker',
  'menu.cms.eventTicker': 'Event Ticker',
  'menu.gms': 'GMS',
  'menu.gms.cashback-games': 'Cashback Games',
  'menu.gms.category-management': 'Category Management',
  'menu.pam.psp': 'PSP',
  'menu.pam.deposit-history': 'Deposit History',
  'menu.pam.manual-deposit': 'Manual Deposit',
  'menu.pam.create-manual-deposit': 'Create Manual Deposit',
  'menu.service-requests': 'Service Requests',
  'menu.service-request.grant-bonus': 'Grant Bonus',
  'menu.service-requests.cashback': 'Cashback',
  'menu.service-requests.Player flag': 'Player Flag',
  'menu.service-requests.create-cashback': 'Create Cashback',
  'menu.loyalty-levels': 'Loyalty Levels',
  'menu.Loyalty Levels.loyalty-levels': 'Loyalty Levels',
  'menu.S3-bucket-list.daily-report': 'Daily Report',
  'menu.S3-bucket-list': 'S3 Bucket List',
  'menu.service-request.llManagerImport': 'LL Manager Import',
  'menu.service-request.create-llManagerImport': 'Create LL Manager Import',
  'menu.service-request.automatedWithdraw': 'Automated Withdrawals',
  'menu.service-request.withdrawalRules': 'Withdrawal Rules',
  'menu.promotions.create-coupon': 'Create Coupon',
  'menu.promotions.create-banner': 'Create Banner',
  'menu.promotions.play-bonus': 'Play Bonus',
};
